const isNil = value => {
  return value === null || value === undefined;
};
const isNotNil = value => {
  return !isNil(value);
};
const getNotNil = function (value) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "unknown";
  if (isNotNil(value)) {
    return value;
  }
  throw new Error(`Value "${name}" is nil.`);
};
export { isNil, isNotNil, getNotNil };